import { useTracking } from 'react-tracking';

import { Link } from '@simplywallst/ui-core/next';
import { ROUTE_ARTICLE } from '@/constants/routes';
import { getPath } from '@/router/utils';

type ArticleDescriptionProps = {
  excerpt: string;
  slug: string;
};
export const Excerpt = ({ excerpt, slug }: ArticleDescriptionProps) => {
  const { trackEvent } = useTracking();

  return (
    <div className="grid grid-rows-[1fr_auto] py-1">
      <div className="min-h-20 px-6 pt-2 [container-type:size]">
        <div className="line-clamp-[3] text-xs text-solid [@container(height>80px)]:line-clamp-[10] ">
          {excerpt}
        </div>
      </div>
      <div className="px-6 pb-2">
        <Link
          href={getPath({
            type: ROUTE_ARTICLE,
            payload: { slug },
          })}
          onClick={() => {
            trackEvent({
              modifier: 'market-latest-article',
              action: 'click',
              slug,
            });
          }}
          className="no-underline"
        >
          <span className="text-xs">Continue reading</span>
        </Link>
      </div>
    </div>
  );
};
